import api from '@services/api.service'
import { createAsyncThunk, EntityId } from '@reduxjs/toolkit'
import { AxiosError } from 'axios'
import { DjangoErrorResponse } from '@store/slices/generic.slice'
import { toast } from 'react-toastify'
import { BroadcastModel } from '@store/slices/broadcast.slice'

const sectionEndpoint = 'broadcast/'

export const generateAudioForBroadcast = createAsyncThunk(
  'broadcast/generateAudio',
  async (id: EntityId) => {
    try {
      const response = await api.get(`${sectionEndpoint}${id}/generate/`)
      return response.data.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se vygenerovat audio'}`
        )
      } else {
        toast.error('Nepodařilo se vygenerovat audio')
      }
      throw axiosError
    }
  }
)

export const duplicateBroadcast = createAsyncThunk(
  'broadcast/duplicate',
  async (props: { copyTo: EntityId }) => {
    try {
      const response = await api.get(
        `${sectionEndpoint}${props.copyTo}/duplicate/`
      )
      return response.data.data as BroadcastModel
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se duplikovat relaci'}`
        )
      } else {
        toast.error('Nepodařilo se duplikovat relaci')
      }
      throw axiosError
    }
  }
)

export const publishBroadcast = createAsyncThunk(
  'broadcast/publish',
  async (id: EntityId) => {
    try {
      const response = await api.get(`${sectionEndpoint}${id}/publish/`)
      return response.data.data
    } catch (error) {
      const axiosError = error as AxiosError
      if (axiosError.response) {
        const serverError = axiosError.response.data as DjangoErrorResponse
        toast.error(
          `Chyba: ${serverError.message || 'Nepodařilo se publikovat relaci'}`
        )
      } else {
        toast.error('Nepodařilo se publikovat relaci')
      }
      throw axiosError
    }
  }
)
